module.exports = __webpack_public_path__ + "static/media/10-sjelden.0a1fc447.mp3";